import { FC } from "react";
import SkeletonMain from "../LoadingMain";
import { Container, Main, MainLeft, MainContent } from "./styles";

export interface ILoadingWidgetNotifications {
  multiple?: number;
}

const LoadingWidgetNotifications: FC<ILoadingWidgetNotifications> = ({
  multiple = 1
}) => {

  const SkeletonUsers = ({ index: _index }: { index: number }) => {
    return (
      <Container>
        <Main>
          <MainLeft>
            <SkeletonMain
              width="32px"
              height="32px"
              borderRadius="50%"
              isCustom="skeleton-custom-dark"
            />
          </MainLeft>
          <MainContent>
            <SkeletonMain
              width="80%"
              height="16px"
              borderRadius="2px"
              isCustom="skeleton-custom-light"
            />
            <SkeletonMain
              width="60%"
              height="16px"
              borderRadius="3px"
              isCustom="skeleton-custom-light"
            />
            <SkeletonMain
              width="120px"
              height="12px"
              borderRadius="2px"
              isCustom="skeleton-custom-light"
            />
          </MainContent>
        </Main>
      </Container>
    )
  }

  const multipleSkeletonsObras = [];
  for (let i = 0; i < multiple; i++) {
    multipleSkeletonsObras.push(SkeletonUsers);
  }

  return (
    <>
      {multipleSkeletonsObras.map((Skeleton, i) => (
        <Skeleton key={`skeleton-key-${i}`} index={i} />
      ))}
    </>
  )
}

export default LoadingWidgetNotifications;
